import React from 'react';
import { Eyebrow, Section } from './Section';
import { offer } from '../data/offer';
export function Guarantee() {
  return <Section tone="paper" labelledBy="garantie-title" data-id="element-119" data-mp="1o2vi2rco2r7m">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-120" data-mp="22369pwlsw9tu">
        <div className="lg:col-span-5" data-id="element-121" data-mp="222mz70yhcnpu">
          <Eyebrow data-id="element-122" data-mp="1x3tn9cyud4rs">Garantie</Eyebrow>
          <h2 id="garantie-title" className="font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-123" data-mp="1x5msqoxpxiy7">
            Garantie de {offer.guaranteeDays} jours
          </h2>
        </div>

        <div className="lg:col-span-7" data-id="element-124" data-mp="1j4k6ab2ta6mr">
          <p className="max-w-prose font-serif text-xl italic leading-relaxed text-graphite md:text-2xl" data-id="element-125" data-mp="1j5lttf10klld">
            Téléchargez-le. Conduisez une Séance Zéro. Installez le Point
            d’Ancrage avec un client.
          </p>
          <p className="mt-8 max-w-prose text-base leading-relaxed text-graphite-mid" data-id="element-126" data-mp="qmeyl52lzmgt">
            Si, dans les {offer.guaranteeDays} jours, le système ne vous
            convient pas, écrivez-nous à{' '}
            <span className="font-medium text-graphite" data-id="element-127" data-mp="oxf966hnsjqz">
              {offer.supportEmail}
            </span>{' '}
            : nous vous remboursons intégralement. Sans formulaire, sans
            justification.
          </p>
        </div>
      </div>
    </Section>;
}